import styled from "styled-components";
import { Div } from "../../common/ui/widgets";

export const MyNotificationsPopUpWrapper = styled(Div)`
  font-family: "Helvetica Neue";
  background-color: ${(props) => props.theme.greyLight};
  font-size: ${(props) => props.theme.fontSize16};
  height: 98vh;
  width: ${(props) => props.theme.width600};
  color: ${(props) => props.theme.darkGrey};
  display: flex;
  justify-content: flex-start;
  > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${(props) => props.theme.padding14} ${(props) => props.theme.padding20};
    background-color: #333333;
    color: #ffffff;

    >div:nth-child(1) {
      font-family: "Helvetica", "texgyreheros-bold", "Tahoma", "Geneva", "Arial",
        sans-serif;
      font-weight: ${(props) => props.theme.fontWeight600};
      font-stretch: expanded;
      line-height: 1.125em;
    }
    .close-activation-popup-button {
      font-size:${(props) => props.theme.font20};
      &:hover {
        cursor: pointer;
      }
    }
  }

  .my-notification-header{
      padding:  ${(props) => props.theme.padding11} ${(props) => props.theme.padding20} !important;
      div{
        padding:0;
      }
    }

  .footer {
    padding: ${(props) => props.theme.padding10} ${(props) =>
    props.theme.padding50};
    >div:nth-child(1) {
      height: ${(props) => props.theme.height20};
      color: #999999;
      font-size: ${(props) => props.theme.fontSize14};
      line-height: ${(props) => props.theme.lineHeight20};
    }
    >div:nth-child(2) {
      color: #5582ba;

      font-size: ${(props) => props.theme.fontSize14};
      line-height: ${(props) => props.theme.lineHeight20};
      margin-top: ${(props) => props.theme.margin8};
    }
  }

  hr {
    margin: 0;
  }

  .sub-header {
    gap:${(props) => props.theme.gap10px};
    background-color: #ebebeb;
    color: #999999;
    .dropdown {
      display: flex;
      justify-content: space-between;
      width: ${(props) => props.theme.width159};
      padding: ${(props) => props.theme.padding9} ${(props) =>
    props.theme.padding11};
      border: 1px solid #dfdfdf;
      background-color: #ffffff;
      span {
        font-size: ${(props) => props.theme.font12};
      }
      :hover {
        cursor: pointer;
      }
      ul {
        li {
          transition: background-color 0.2s;
          &:hover {
            background-color: #f1f1f1;
            cursor: pointer;
          }
        }
      }
    }
    .select-input {
      display: flex;
      gap:  ${(props) => props.theme.gap10px};
      align-items: center;
      input[type="checkbox"] {
        height: ${(props) => props.theme.height16};
        width: ${(props) => props.theme.width16};
        margin: 0;
      }
      label {
        margin: 0;
        font-size: ${(props) => props.theme.font14};
        font-weight: ${(props) => props.theme.fontWeight400};
      }
      :hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
  }

  .drop-down {
    position: absolute;
    width: 100%;
    top: ${(props) => props.theme.top37};
    left: 0;
    padding: ${(props) => props.theme.padding15};
    border: 1px solid #dfdfdf;
    background-color: #ffffff;
    z-index:2;
    ul {
      margin: 0;
      padding: 0;
    }
    li {
      color: #666666;
      padding: 0 ${(props) => props.theme.padding9};
      list-style: none;
      :hover {
        background-color: #f1f1f1;
        cursor: pointer;
      }
    }
  }

  .read-delete-icons {
    display: flex;
    flex-direction: row;
    gap: ${(props) => props.theme.gap8};
    align-items: center;
    div {
      width: ${(props) => props.theme.width25};
      height: ${(props) => props.theme.height25};
      img {
        width: ${(props) => props.theme.width100Percentage};
        height: auto;
      }
    }
    .seperator {
      width: ${(props) => props.theme.width2};
      height: ${(props) => props.theme.height17};
      border: 1px solid #cccccc;
    }
  }
  .notifications-list {
    flex-direction: column;
    display: flex;
    gap: ${(props) => props.theme.gap20px};
    margin: 0 auto;
    overflow: auto;
  }

  .notification-list {
    box-sizing: border-box;
    width: ${(props) => props.theme.width554};
    border: 1px solid #e6e6e6;
    background-color: #ffffff;
    .notification-list-header {
      display: flex;
      align-items: center;
      color: #ffffff;
      gap: ${(props) => props.theme.gap10px}; 
      width: auto;
      height: auto;
      input[type="checkbox"] {
        box-sizing: border-box;
        height: ${(props) => props.theme.height16};
        width: ${(props) => props.theme.width16};
        border: 1px solid #b2b2b2;
        border-radius: ${(props) => props.theme.width1};
        background-color: #ffffff;
        margin: ${(props) => props.theme.margin12} ${(props) =>
    props.theme.margin12} ${(props) => props.theme.margin10} ${(props) =>
      props.theme.margin12};
      }
    }
    .notification-list-body {
      display: flex;
      flex-wrap:wrap;
      height: auto;
      width: auto;
      margin: ${(props) => props.theme.margin33} ${(props) =>
    props.theme.margin50};
      justify-content: space-between;
      align-items: center;
      .chip {
        color: #191919;
        font-family: Roboto;
        font-size: ${(props) => props.theme.font14};
        line-height: ${(props) => props.theme.lineHeight14};
        text-align: center;
        padding: ${(props) => props.theme.padding5};
        width: ${(props) => props.theme.width112} !important;
        border: 1px solid #e03d3d;
        border-radius: ${(props) => props.theme.borderRadius100};
        background-color: #e251531a;
      }
    }
    .notification-list-footer {
      text-align: right;
      padding: ${(props) => props.theme.padding10} ${(props) =>
    props.theme.padding50};
      padding-top: 0;
      font-size: ${(props) => props.theme.font14};
      color: #b3b3b3;
      line-height: ${(props) => props.theme.lineHeight21};
      font-style: normal;
      letter-spacing: 0;
      opacity: ${(props) => props.theme.opacity1};
      vertical-align: middle;
      font-weight: normal;
    }
    .padding0 {
      padding: 0;
    }
    .margin5 {
      margin: ${(props) => props.theme.margin5} ${(props) =>
    props.theme.margin50};
    }

    .temperature {
      height: ${(props) => props.theme.height32};
      color: #4d4d4d;
      font-family: "Helvetica Neue";
      font-size: ${(props) => props.theme.font24};
      line-height: ${(props) => props.theme.lineHeight32};
    }
  }

  .pop-footer-btn {
    border: 1px solid #e6e6e6;
    justify-content: flex-end;
    background-color: #ebebeb;
    margin-top: auto;
  }

  .pop-footer-btn button {
    padding: ${(props) => props.theme.padding12} ${(props) =>
    props.theme.padding20};
    margin-left: ${(props) => props.theme.margin10};
  }

  .flex-wrap {
    select {
      padding: ${(props) => props.theme.padding10} 0;
    }
  }

  .loader{
    width: inherit;
    justify-content: center;
    background: transparent;
    margin: auto;
  }

  @media only screen and (max-width: 600px) {
    height: 90vh;
    width: 90%;
    .notification-list {
    width: auto;
}
  }

  @media only screen and (max-width: 500px) {
    height: 90vh;
    width: 90%;
    .notification-list {
    width: auto;
}
  }

  @media only screen and (max-width: 430px) {
    width: 95%;
    .flex-wrap {
      flex-wrap: wrap;
    }
    .flex-wrap div {
      width: 100% !important;
    }
    .notification-list{
        width: auto;
    }
  }

  @media only screen and (min-height: 1060px) {
    height: 90vh;
    width: 70%;
    .notification-list {
    width: auto;
}
  }

  @media screen and (max-width: 280px) {
    .sub-header {
    flex-wrap:wrap;
    }
}
`;